import {commonPalette} from './palette';

//constants
const bulletWidth = 0.2;
const counterWidth = 0.8; // ordered list marker (digit + dot) width
const lineHeight = 1.5;
export const indentation = 0.725 * lineHeight;

export const blockMargin = lineHeight / 2;

export const getFormattedTextStyle = (shouldCollapseMargins = false) => `
  line-height: ${lineHeight};
  p, ul, ol, li {
    ${
      shouldCollapseMargins
        ? `
      margin: 0;
    `
        : `
      margin: 0 0 ${blockMargin}em;

      &:last-child {
        margin-bottom: 0;
      }
    `
    }
  }

  ul, ol {
    list-style: none;
    padding: 0;
  }

  ol {
    counter-reset: ol;
  }

  li {
    padding-left: ${indentation}em;
    position: relative;
    min-height: ${lineHeight}em; 
  }

  /* draftjs-to-html emits a nested ul/ol as a direct child of the parent list;
     padding (not margin) so indentation survives shouldCollapseMargins. */
  ul ul,
  ul ol,
  ol ul,
  ol ol {
    padding-left: ${indentation}em;
  }

  ul > li::before {
    background: currentColor;
    border-radius: 50%;
    content: '';
    height: ${bulletWidth}em;
    left: ${counterWidth / 3}em;
    position: absolute;
    top: ${(lineHeight - bulletWidth) / 2}em;
    width: ${bulletWidth}em;
  }

  ol > li::before {
    content: counter(ol) '.';
    counter-increment: ol;
    margin-right: ${-counterWidth}em;
    position: absolute;
    right: 100%;
    top: 0;
  }

  a {
    color: ${commonPalette.linkBlue};
  }

  overflow-wrap: break-word;
`;
